module.exports = __webpack_public_path__ + "static/media/planning-new.bdc4f724.jpg";